import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { ReactImageGalleryItem } from 'react-image-gallery';

export type ReactImageGalleryItemCustom = ReactImageGalleryItem & {
  type: 'video' | 'image';
};

export const GalleryNavigationLeft = (
  onClick: React.MouseEventHandler<HTMLElement>,
  disabled: boolean,
) => (
  <Button
    variant="text"
    disabled={disabled}
    onClick={(ev) => {
      ev.stopPropagation();
      onClick(ev);
    }}
    className="w-[50px]"
  >
    <FontAwesomeIcon
      icon={faArrowLeft}
      className={classNames({
        'text-white': !disabled,
        'text-gray': !disabled,
      })}
    />
  </Button>
);

export const GalleryNavigationRight = (
  onClick: React.MouseEventHandler<HTMLElement>,
  disabled: boolean,
) => (
  <Button
    variant="text"
    disabled={disabled}
    onClick={(ev) => {
      ev.stopPropagation();
      onClick(ev);
    }}
    className="w-[50px] order-3"
  >
    <FontAwesomeIcon
      icon={faArrowRight}
      className={classNames({
        'text-white': !disabled,
        'text-gray': !disabled,
      })}
    />
  </Button>
);

export const RenderGalleryItem = (item: ReactImageGalleryItemCustom) => (
  <div
    className={classNames(
      'flex justify-center items-center md:h-[500px] md:w-[670px]',
    )}
  >
    {item.type === 'image' ? (
      <img
        src={item.original}
        className={classNames(
          'rounded-[10px] margin-auto object-contain md:max-h-[500px]',
        )}
        loading="lazy"
      />
    ) : (
      <video
        src={item.original}
        className="rounded-[10px] max-h-[500px] max-w-[670px]"
        controls={true}
      />
    )}
  </div>
);

export const RenderGalleryThumbnail = (item: ReactImageGalleryItemCustom) => (
  <div className="relative">
    {item.type === 'video' && (
      <div className="absolute bottom-0 left-0 right-0 top-0 grid place-items-center">
        <FontAwesomeIcon icon={faPlay as IconProp} className="text-white" />
      </div>
    )}
    <img
      src={item.thumbnail}
      className="rounded-[10px] h-[90px] object-cover m-auto"
      loading="lazy"
    />
  </div>
);
